<div class="unavailable-item"
     id="unavailCartItem_{{cartItem.name | replaceStr}}">
  <div id="trash-icon">
    <i nz-icon nzType="icons/fontawesome/regular:trash-alt"
       (click)="deleteCartItem()"></i>
  </div>

  <div id="cart-item-name" class="cart-item-header"
       style="text-align: left">
    <span nz-tooltip nzTooltipTitle="{{cartItem.name}} is currently not available. Please remember to remove item before placing order"
      nzTooltipPlacement="bottom"
          tooltipStyleClass="unavailable-item-tooltip"
          [hidden]="!detailed"
      [nzTooltipMouseEnterDelay]="200">{{cartItem.name}} <i nz-icon nzType="icons/fontawesome/solid:exclamation-triangle"></i></span>
  </div>
</div>

<hr *ngIf="!last">
